export const checkForNaStringValue = (str: string): string | null => {
  if (!str || str.toLowerCase() === "n/a" || str === "") {
    return null;
  }

  return str;
};
